import {
  DAON_CALLBACK,
  SESSION_EXPIRED_STATUS_CODE,
} from "logic/enums/composite";
import { webView } from "logic/webView";

export function handleCompositeRestart() {
  webView(DAON_CALLBACK, SESSION_EXPIRED_STATUS_CODE);
}
